import { css } from 'styled-components';

export const sizeProps = ({ height, width, minHeight, minWidth }) => css`
  height: ${height};
  min-height: ${minHeight};
  width: ${width};
  min-width: ${minWidth};
`;
